"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _models = require("@nopanoga/models");

var _Util = require("../Util");

var _Button = require("../Button/Button");

var _LinearGradient = _interopRequireDefault(require("../LinearGradient"));

var _Griffe = _interopRequireDefault(require("../Assets/Griffe"));

var _Text = require("../Text");

var _Icons = _interopRequireDefault(require("../Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = _reactNative.StyleSheet.create({
  container: {
    zIndex: 14,
    height: '100%',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  infosContainer: {
    width: '100%',
    paddingHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center'
  }
});

var styleInline = {
  button: {
    width: '48%',
    height: 55,
    fontSize: 20,
    textTransform: 'uppercase',
    position: 'absolute',
    bottom: 30
  }
};

var _default = function _default(_ref) {
  var stats = _ref.stats,
      onClickClose = _ref.onClickClose;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.infosContainer
  }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    color: "white",
    style: {
      fontSize: 48
    }
  }, "Bien jou\xE9 !"), /*#__PURE__*/_react["default"].createElement(_Griffe["default"], null), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    color: "white",
    style: {
      fontSize: 25,
      marginTop: 50
    }
  }, "Temps total : ", (0, _Util.renderTime)(stats.time, 'short'))), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    style: styleInline.button,
    title: "Fermer",
    onPress: onClickClose,
    color: "app-primary"
  }));
};

exports["default"] = _default;